import "./GenericSmallTable.css";

const GenericSmallTable = ({ dados, corValor = "verde" }) => {
  return (
    <table className="resumo-apoio-table">
      <tbody>
        {dados.map((item, index) => {
          const isTotal = item.label === "VALOR TOTAL DO APOIO";
          return (
            <tr key={index} className={isTotal ? "resumo-total-row" : ""}>
              <td
                className={`resumo-label${isTotal ? " resumo-label-bold" : ""}`}
              >
                {item.label}
              </td>
              <td
                className={`resumo-valor valor-${corValor}${isTotal ? " resumo-valor-bold" : ""}`}
              >
                {item.valor}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default GenericSmallTable;
